import { withAnalyticsEvents as withAKAnalyticsEvents } from '@atlaskit/analytics-next';
export function withAnalytics(component) {
  return withAKAnalyticsEvents()(component); // eslint-disable-line flowtype/no-weak-types
}